import { createContext, useState } from 'react';

const MessagingHistoryContext = createContext({
  dataState: {
    items: [],
    total: 0,
    pageCount: 0,
    loading: false,
    status: 'idle',
  },
  updateDataState: () => {},
});

export const MessagingHistoryContextProvider = ({ children }) => {
  const [dataState, setDataState] = useState({
    items: [],
    total: 0,
    pageCount: 0,
    loading: false,
    status: 'idle',
  });

  const updateDataState = (newState) => {
    setDataState((prevState) => ({
      ...prevState,
      ...newState,
    }));
  };

  const context = {
    dataState,
    updateDataState,
  };

  return (
    <MessagingHistoryContext.Provider value={context}>
      {children}
    </MessagingHistoryContext.Provider>
  );
};

export default MessagingHistoryContext;
